module.exports = __webpack_public_path__ + "img/new-gif.9771116c.gif";